<template>
  <div>
    <div v-if="containerType == 1">
      <div class="rc-tabs">
        <!-- <ul class="rc-tabs-ul">
          <li
            @click="tabsClick(item.goodsCategoryId)"
            :class="tabsActiveId == item.goodsCategoryId?'is-active':'' "
            class="rc-tabs-item"
            v-for="(item,index) in tabsList"
            :key="index"
          >{{item.categoryName}}</li>
        </ul> -->
        <el-tabs v-model="editableTabsValue" type="card" @tab-click="show_upsPage" class="sub">
          <el-tab-pane :key="item.name"
            v-for="item in tabsList"
            :label="item.categoryName"
            :id="item.goodsCategoryId"
            :name="item.categoryName">
        </el-tab-pane>
      </el-tabs>
      </div>
      <!-- @keyup.enter="searchGoods" -->
      <div class="rc-content">
        <div class="rc-search-wrapper">
          <!-- <div class="search-input">
            <input
              v-model="searchVal"
              class="input__inner"
              @blur="selectSearch"
              placeholder="搜索商品"
            />
            <div class="rc-searchIcon">
              <img src="../../assets/icon/search.png" alt class="rc-searchImg" @click="selectSearch" />
            </div>
          </div> -->
          <el-input placeholder="请输入搜索商品" v-model="searchVal" @blur="selectSearch" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"  @click="selectSearch"></el-button>
          </el-input>
          <div @click="switchMode" class="rc-switchMode">
            <img v-if="switchImg" src="../../assets/icon/xstp.png" alt class="rc-switchMode_icon" />
            <img v-if="!switchImg" src="../../assets/icon/yctp.png" alt class="rc-switchMode_icon" />
          </div>
        </div>
        <div :class="switchImg?'rc-goods-wrapper':'rc-goods-wrapper2'">
          <div
            class="goods-item"
            v-for="(item,index) in commidityList"
            :key="index"
            @click="selectProducts(item)"
          >
            <div class="goods-item-img" v-if="switchImg">
              <img v-if="item.goodsImage" :src="item.goodsImage" class alt />
              <img v-if="!item.goodsImage" src="../../assets/icon/defaultPic.png" class alt />
            </div>
            <div class="goods-item-content">
              <div class="goods-item-title">{{item.goodsName}} <span v-if="item.valueContent">({{item.valueContent}})</span></div>
              <div class="goods-item-type center" v-if="item.unitType == 2">称重</div>
              <div style="margin-top: -12px;">
                <span class="goods-item-price">￥{{item.retailPrice}}</span>
                <span class="goods-item-stocks" v-if="item.memberPrice">会员价:￥{{item.memberPrice}}</span>
              </div>
              <div style="margin-top: -15px; font-size: 12px; color: rgb(199,203,205)"> 
                <span v-if="!item.isInfiniteStock" >库存：{{item.qrcTotalStockCount}}</span> </div>
                <span v-if="item.isInfiniteStock" style="font-size: 12px; color: rgb(199,203,205)">库存：无限库存</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rc-bottom">
        <el-button type="primary" plain @click="addGoodsMonads">挂单</el-button>
        <el-button class="takeOutBill" type="primary" plain @click="jump('goodsMonads')">
          <div class="cicrle center" v-if="goodsMonads">{{goodsMonads}}</div>取单
        </el-button>
        <el-button type="primary" @click="jump('cashierOrderNoBarcode')" plain>无码收银</el-button>
        <el-button type="primary" plain @click="goAllDiscount">整单优惠</el-button>
        <el-button type="primary" @click="cashCoupon" plain>卡券核销</el-button>
        <el-button type="primary" plain @click="jump('cashierOrderVip')">会员</el-button>
        <el-button type="primary" plain @click="jump('cashierOrderMoreFunction')">更多功能</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { goodsCategoryPager, getCardDetail } from "../api";
export default {
  data() {
    return {
      containerType: 1, //1:商品列表 2：选择规格
      todaySale: [],
      cartList: [],
      tabsList: [{ categoryName: "全部", goodsTypes: "" }],
      tabsActiveId: undefined,
      searchVal: "", //搜索商品
      switchImg: true,
      userList: "",
      shopInformation: "",
      commidityList: [], //商品数组
      goodsMonads: "",
      editableTabsValue: ""
    };
  },
  created() {
    document.onselectstart = function(){return false;};
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.goodsCategoryList();
    this.Goods_goodsList();
    if (window.localStorage.goodsMonads) {
      this.goodsMonads = JSON.parse(window.localStorage.goodsMonads).length;
    }
    if (window.localStorage.cashierImgShow == "false") {
      this.switchImg = false;
    } else {
      this.switchImg = true;
    }
  },
  methods: {
    show_upsPage(e) {
      this.$emit("open", e)
      // console.log(this.tabsList, e.$attrs.id, 'e')
      this.Goods_goodsList(e.$attrs.id);
    },
    goAllDiscount() {
      if (this.$store.state.cartList.length == 0) {
        this.$message.error("请先添加商品");
        return;
      }
      this.jump("cashierOrderAllDiscount");
    },
    //当前时间
    getTime(date) {
      if (date) {
        var myDate = date;
      } else {
        var myDate = new Date();
      }
      myDate.getYear(); //获取当前年份(2位)
      var month = myDate.getMonth() + 1;
      let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      var date = myDate.getDate();
      var hours = myDate.getHours();
      var minutes = myDate.getMinutes();
      var seconds = myDate.getSeconds();
      if (date < 10) {
        date = "0" + date;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      var time =
        myDate.getFullYear() +
        "-" +
        month +
        "-" +
        date +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      return time;
    },
    //挂单
    addGoodsMonads() {
      var cartList = this.$store.state.cartList;
      var time = this.getTime();
      if (cartList.length == 0) {
        this.$message.error("请先添加商品");
        return;
      }
      // Object.values()//对象转数组
      var arr = { list: [] };
      var arr2 = [];
      if (window.localStorage.goodsMonads) {
        arr2 = JSON.parse(window.localStorage.goodsMonads);
      }
      cartList.forEach((e, a) => {
        arr.list.push(e);
      });
      arr.time = time;
      arr.saleUserId = this.$store.state.saleUserId;
      arr.orderMark = "";
      arr2.push(arr);
      //重新排序
      arr2.forEach(item => {
        var str = item.time.replace(/-/g, "/");
        var date = new Date(str);
        item.time = date.getTime();
      });

      var compare = function(prop) {
        return function(obj1, obj2) {
          var val1 = obj1[prop];
          var val2 = obj2[prop];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
          }
          if (val1 < val2) {
            return 1;
          } else if (val1 > val2) {
            return -1;
          } else {
            return 0;
          }
        };
      };
      arr2 = arr2.sort(compare("time"));
      arr2.forEach(item => {
        var date = new Date(item.time);
        item.time = this.getTime(date);
        // console.log(this.getTime(date), "date");
      }); //重新排序

      console.log(arr2);
      // return;
      window.localStorage.setItem("goodsMonads", JSON.stringify(arr2));
      this.goodsMonads = JSON.parse(window.localStorage.goodsMonads).length;
      console.log(JSON.parse(window.localStorage.goodsMonads));
      this.$store.commit("clearOffers");
      this.$store.state.saleUserId = ""; //去除销售员
      this.$message({
        type: "success",
        message: "挂单成功"
      });
      this.clearAll();
    },
    // 整单取消
    clearAll() {
      this.$store.state.cartList = [];
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
    },
    jump(adress) {
      this.$router.push({ path: adress });
    },
    //卷码核销
    cashCoupon() {
      this.$prompt("请输入优惠券/码", "优惠券/码核销", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          var code = value
          this.$confirm("已使用其他优惠，不可与优惠券同时使用，是否使用优惠券？", {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          })
          .then(({ value }) => {
            getCardDetail({
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              cashCouponCode: code
            }).then(res => {
              console.log(res, "juanma");
              if (res.code == 1) {
                if (res.data.usedStatus == 1 || res.data.usedStatus == 3) {
                  this.$store.state.offers.cashCoupon = res.data;
                  this.$store.state.offers.type = 1;
                  this.$store.commit("countTotalPrice");
                  this.$store.commit("countCartListPrice");
                  this.$message({
                    type: "success",
                    message: "success"
                  });
                } else {
                  this.$message({
                    type: "warning",
                    message: "该卷码不可用"
                  });
                }
              } else {
                this.$message.error(res.msg);
              }
            });
          })
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    //选择商品
    selectProducts(item) {
      if (item.unitType == 1) {
        if (!item.isInfiniteStock && item.qrcTotalStockCount == 0) {
          this.$message({
            type: "warning",
            message: "库存不足"
          });
          return;
        }
        var arr = item; //选择的商品
        var shoppingTrolley = this.$store.state.cartList;
        var idArr = [];
        var idNum = []; // id下标对应的商品数量
        var istrue = false; //判断选中商品是否存在购物车
        var index = null;
        console.log(shoppingTrolley);
        for (let a of shoppingTrolley) {
          idArr.push(a.productId);
          idNum.push(a.goodsNum);
        }
        for (let i in idArr) {
          if (idArr[i] == arr.productId) {
            istrue = true;
            index = i;
            if (item.isInfiniteStock == 0 && idNum[i] >= item.qrcTotalStockCount) {
              this.$message({
                type: "warning",
                message: "购物车选择商品库存不足"
              });
              return;
            }
          } else {
            // istrue = false;
          }
        }
        if (istrue) {
          let newGoodsNum = shoppingTrolley[index].goodsNum + 1;
          // this.$set(shoppingTrolley[index], 'purchasingCost', this.purchasingCost)
          this.$set(shoppingTrolley[index], "goodsNum", newGoodsNum);
          this.$store.state.cartList = []; //直接赋值页面不刷新
          this.$store.state.cartList = shoppingTrolley;
          if (this.$store.state.takeOutCartList) {
            this.$store.state.takeOutCartList.list = shoppingTrolley;
          }
        } else {
          arr.goodsNum = 1;
          shoppingTrolley.push(arr);
          this.$store.state.cartList = shoppingTrolley;
          if (this.$store.state.takeOutCartList) {
            this.$store.state.takeOutCartList.list = shoppingTrolley;
          }
        }
        if (this.$store.state.offers.type == 2) {
          this.$store.state.offers.type = 0;
          this.$store.state.offers.reducePrice = 0;
        } else if (this.$store.state.offers.type == 3) {
          this.$store.state.offers.type = 0;
           this.$store.state.offers.discountNumber = 0;
        }
        this.$store.commit("countTotalPrice");
        this.$store.commit("countCartListPrice");

        this.$message({
          type: "success",
          message: "添加商品：" + item.goodsName,
          duration: 500
        });
        return;
      } else {
        if (!item.isInfiniteStock && item.qrcTotalStockCount == 0) {
          this.$message({
            type: "warning",
            message: "库存不足"
          });
          return;
        }
        item = JSON.stringify(item);
        this.$router.push({ path: "goodsDetails", query: { item: item } });
      }
    },
    //选中输入框
    selectSearch() {
      this.Goods_goodsList("","", 999, 1, this.searchVal);
      this.$emit("open", this.searchVal)
    },
    // 清空输入框的值并恢复商品初始化
    clearContent() {
      this.Goods_goodsList("","", 999, 1)
      this.searchVal = ""
      this.goodsTypes = ""
      this.categoryName = "全部"
    },
    //回车搜索商品
    // searchGoods() {
    //   this.Goods_goodsList();
    // },
    //商品列表
    Goods_goodsList(goodsCategoryId, goodsName, pageSize, pageNumber, synthesisSearch) {
      this.request
        .post("qrcapi/RepositoryGoodsDetail_repositoryGoodsDetailList", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          shopId: this.shopInformation.shopId, //商店id
          goodsCategoryId: goodsCategoryId, //分类id
          synthesisSearch: synthesisSearch, //商品名字
          row: 99999, // 每页记录数
          saleStatus: 1
        })
        .then(res => {
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            var arr = res.data;
            arr.forEach(item => {
              if (item.goodsImage) {
                item.goodsImage = item.goodsImage.replace("YM0000", "100X100");
              }
              // console.log(index)
            });
            this.commidityList = arr;
            this.$store.state.commidityList = arr;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.commidityList = "";
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("商品接口网络错误，不能访问");
          console.log(error);
        });
    },
    //分类列表
    goodsCategoryList(pageNo, pageSize) {
      goodsCategoryPager({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNumber: pageNo,
        pageSize: 99
      })
        .then(res => {
          // console.log(res.data, "分类列表");
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            var num = 0;
            this.tabsList = [{ categoryName: "全部", goodsTypes: "" }];
            for (let i in res.data.pager.list) {
              // console.log(res.data.pager.list, '分类列表')
              this.tabsList.push(res.data.pager.list[i]);
              num += res.data.pager.list[i].goodsTypes;
            }
            this.totalCount2 = res.data.pager.totalCount;
            this.tabsList[0].goodsTypes = num;
            this.goodsCategoryId = "";
            // console.log(this.tabsList, "tableData");
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    //商品图片显示隐藏
    switchMode() {
      this.switchImg = !this.switchImg;
      window.localStorage.setItem("cashierImgShow", this.switchImg);
      console.log(this.switchImg);
    },
    //点击标签栏
    tabsClick(id) {
      this.Goods_goodsList(id);
      // console.log(id, "11");
      this.tabsActiveId = id;
    }
  }
};
</script>

<style scoped>
.takeOutBill {
  position: relative;
}
.takeOutBill .cicrle {
  content: "123";
  background: red;
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
}
.emptyCL-value {
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.emptyCartList {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.emptyCartList img {
  height: 90px;
  width: 90px;
  margin-bottom: 20px;
}
.el-select {
  width: 100px;
}
.goods-item-stocks {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666;
  line-height: 48px;
}
.goods-item-price {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(249, 35, 35, 1);
  line-height: 43px;
  margin-right: 10px;
}

.goods-item-type {
  background: #dfeffa;
  width: 50px;
  height: 24px;
  border-radius: 1px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(16, 142, 233, 1);
  line-height: 20px;
}
.goods-item-title {
  min-height: 40px;
  font-size: 14px;
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  word-wrap: break-word;
}
.rc-goods-wrapper2 {
  position: relative;
  top: 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 175px));
  /* grid-template-rows: repeat(2,100px); */
  grid-gap: 20px;
}
.rc-goods-wrapper {
  position: relative;
  top: 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 275px));
  /* grid-template-rows: repeat(2,100px); */
  grid-gap: 20px;
}
.goods-item-img img {
  height: 100%;
  width: 100%;
}
.goods-item-img {
  height: 100%;
  width: 100px;
  display: flex;
  flex-shrink: 0;
}
.goods-item-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding: 10px;
  font-size: 14px;
}
.goods-item {
  position: relative;
  box-sizing: border-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: auto;
  height: 108px;
  overflow: hidden;
  color: #333;
  cursor: pointer;
  background-color: #f8f8f9;
  border-radius: 2px;
}
.rc-searchImg {
  height: 24px;
  width: 24px;
}
.rc-searchIcon {
  position: absolute;
  left: 10px;
  top: 7px;
}
.input__inner {
  background: #f8f8f9;
  font-size: 14px;
  color: #323233;
  background: #f8f8f9;
  caret-color: #1989fa;
  border: none;
  border-radius: 2px;
  padding: 9px 40px;
  width: 100%;
  box-sizing: border-box;
  height: 40px;
}
.rc-switchMode_icon {
  height: 27px;
  width: 29px;
  margin-bottom: 3px;
}
.rc-switchMode {
  height: 40px;
  width: 40px;
  position: absolute;
  /* right: 0px; */
  right: -50px;
  top: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-input {
  position: absolute;
  left: 0;
  right: 40px;
}
.rc-search-wrapper {
  position: relative;
  width: 95%;
}

.rc-bottom {
  height: 64px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eee;
  padding: 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(9, minmax(100px, 1fr));
  grid-template-rows: repeat(2, 1fr);
}
.rc-content::-webkit-scrollbar {
  display: none;
}
.rc-content {
  padding: 10px;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 64px;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-y: overlay;
}
.is-active::after {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  bottom: 0px;
  border: 1px solid #1e94ea;
}
.is-active {
  color: #1e94ea;
  font-weight: bold;
}
.rc-tabs-item {
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 100%;
  line-height: 50px;
  padding: 0 15px;
  font-size: 7px;
}
.rc-tabs-ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
.rc-tabs-ul::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.rc-tabs-ul::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.rc-tabs-ul {
  position: relative;
  padding: 0;
  height: 100%;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
li {
  list-style: none;
}
.rc-tabs {
  position: absolute;
  height: 60px;
  /* background-color: #eeeeee; */
  top: 0;
  left: 0;
  right: 0;
}
.catHead-salesman {
  font-size: 6px;
  font-weight: 400;
  color: rgba(30, 148, 234, 1);
  margin-top: 4px;
}
.catHead-cashier {
  font-size: 6px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.cartActions-button {
  margin-left: 10px;
}

.cartSummary-payNumber {
  margin-top: 10px;
  overflow: hidden;
  clear: both;
  font-weight: bold;
}

.cartSummary-discount {
  display: flex;
  justify-content: space-between;
}
.discount-val {
  color: #f92323;
}

.cart-item__total {
  width: 40%;
  text-align: right;
}
.cart-item__amount {
  width: 20%;
  text-align: right;
}
.cart-item__unit {
  width: 10%;
  text-align: right;
}
.cart-item__price {
  width: 30%;
}
.cartItemDelete {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 18px;
  color: #1989fa;
  cursor: pointer;
}
.cartItemName {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cart-item__btm {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 7px;
  font-size: 14px;
  line-height: 18px;
  color: #323233;
}
.cart-item__sku {
  min-height: 1em;
  margin-top: 6px;
  font-size: 12px;
  line-height: 16px;
  color: #646566;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cart-item__hd {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  color: #323233;
}
.cart-item::after {
  position: absolute;
  right: 10px;
  bottom: 0;
  left: 10px;
  height: 0;
  content: "";
  border-top: 1px dashed #dcdee0;
}
.cart-item {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 80px;

  padding: 10px 15px;
}
.cartSummary {
  position: absolute;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  box-shadow: none;
  bottom: 0;
  font-size: 14px;
  height: 74px;
  box-sizing: border-box;
  width: 100%;
  padding: 14px 17px 0 15px;
  font-size: 14px;
}
.cartListInner {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.cartHead {
  padding: 0 15px;
  height: 60px;
  box-shadow: 0 1px 0 #e5e5e5;
  background: #eee;
}
.cartList {
  position: absolute;
  top: 60px;
  bottom: 64px;
  left: 0;
  right: 0;
  flex-grow: 1;
  flex-shrink: 1;
  margin-bottom: 1px;
}
#cashierOrderHome {
  min-width: 800px;
  background: #f8f8f8;
  height: 100vh;
  width: 100vw;
}
.main-container-wrapper {
  position: absolute;
  top: 75px;
  right: 0;
  bottom: 20px;
  left: 0;
}

.main-container {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  min-height: 480px;
  margin: 0 20px;
}
.container-aside {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 400px;
  background-color: #fff;
  box-shadow: 0 0 4px 0 rgba(195, 195, 195, 0.5);
}
.container-body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 420px;
  background-color: #fff;
}
.shoopingCart {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 64px;
  left: 0;
}
.cartActions {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  height: 64px;
  padding: 0 15px;
  box-shadow: 0 0 4px 0 rgba(195, 195, 195, 0.5);
}
@media screen and (min-width: 1650px) {
  .main-container {
    max-width: 1600px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 960px) {
  .main-container {
    margin: 0 10px;
  }
  /* .container-aside {
    width: 300px;
  } */
  /* .container-body {
    left: 310px;
  } */
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderHome.vue